import React from 'react';
import { Building2, MessageCircle, CheckCircle2, FileText, Search, Calculator } from 'lucide-react';
import WhatsAppActivation from './WhatsAppActivation';

const SuccessPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100">
      <div className="container mx-auto px-4 py-12 md:px-8">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="flex items-center justify-center mb-6">
              <Building2 className="h-12 w-12 text-blue-700 mr-3" />
              <span className="font-bold text-3xl text-blue-800">ImóvelIA</span>
            </div>
            <div className="bg-green-50 p-4 rounded-full inline-flex items-center gap-2 mb-8">
              <CheckCircle2 className="h-6 w-6 text-green-600" />
              <span className="text-green-700 font-medium">Pagamento confirmado!</span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Bem-vindo ao ImóvelIA Premium! 🚀
            </h1>
            <p className="text-xl text-slate-600">
              Você agora tem acesso ao assistente via web e WhatsApp!
            </p>
          </div>
          
          <div className="mt-12 space-y-8">
            <div className="bg-white rounded-xl shadow-lg border border-slate-100 p-8">
              <h2 className="text-2xl font-semibold mb-6">Como usar o ImóvelIA</h2>
              
              <div className="grid gap-8">
                <div className="flex items-start gap-4">
                  <div className="bg-blue-100 p-3 rounded-lg">
                    <MessageCircle className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-medium text-lg mb-2">1. Ative o WhatsApp</h3>
                    <p className="text-slate-600 mb-4">
                      Clique no botão abaixo para ativar o assistente no seu WhatsApp.
                      Você receberá uma mensagem de confirmação em instantes.
                    </p>
                    <WhatsAppActivation />
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-blue-100 p-3 rounded-lg">
                    <FileText className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-medium text-lg mb-2">2. Envie documentos para análise</h3>
                    <p className="text-slate-600">
                      Você pode enviar:
                    </p>
                    <ul className="mt-2 space-y-2 text-slate-600">
                      <li className="flex items-center gap-2">
                        <div className="h-1.5 w-1.5 rounded-full bg-blue-600"></div>
                        Editais de leilão
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="h-1.5 w-1.5 rounded-full bg-blue-600"></div>
                        Matrículas de imóveis
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="h-1.5 w-1.5 rounded-full bg-blue-600"></div>
                        Links de imóveis em leilão
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="bg-blue-100 p-3 rounded-lg">
                    <Calculator className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-medium text-lg mb-2">3. Receba análises completas</h3>
                    <p className="text-slate-600">
                      O assistente irá analisar e te enviar:
                    </p>
                    <ul className="mt-2 space-y-2 text-slate-600">
                      <li className="flex items-center gap-2">
                        <div className="h-1.5 w-1.5 rounded-full bg-blue-600"></div>
                        Identificação de riscos e oportunidades
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="h-1.5 w-1.5 rounded-full bg-blue-600"></div>
                        Cálculos de viabilidade e ROI
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="h-1.5 w-1.5 rounded-full bg-blue-600"></div>
                        Recomendações personalizadas
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Support Info */}
          <div className="mt-8 text-center text-sm text-slate-600">
            <p>
              Precisa de ajuda? Entre em contato pelo email:{' '}
              <a href="mailto:minasdouglas@yahoo.com.br" className="text-blue-600 hover:text-blue-800">
                minasdouglas@yahoo.com.br
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage